import { createStyles } from "@material-ui/core";

export default (theme) =>
  createStyles({
    root: {
      width: "80%",
    },
  });